// extracted by mini-css-extract-plugin
module.exports = {"modelviewer":"Modelviewer_modelviewer__q_01g","modelviewerWrapper":"Modelviewer_modelviewerWrapper__jLajp"};